<template>
  <div class="template-container">
    <!-- 头部操作栏 -->
    <div class="header-toolbar">
      <div class="toolbar-left">
        <h2 class="page-title">
          <i class="el-icon-message"></i>
          模版管理
        </h2>
      </div>
    </div>

    <!-- Tab 切换 -->
    <div class="tabs-container">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="消息模版" name="message">
          <!-- 消息模版搜索栏 -->
          <div class="search-toolbar">
            <el-input
              v-model="messageQuery.template_name"
              placeholder="请输入模版名称搜索"
              clearable
              @clear="getMessageList"
              @keyup.enter.native="getMessageList"
              style="width: 300px;"
              class="search-input"
            >
              <el-button slot="append" icon="el-icon-search" @click="getMessageList"></el-button>
            </el-input>
            <el-button type="primary" icon="el-icon-plus" @click="handleMessageAdd">新增消息模版</el-button>
          </div>

          <!-- 消息模版卡片列表 -->
          <div class="cards-container" v-loading="messageLoading">
            <div class="card-item" v-for="item in messageList" :key="item.id">
              <!-- 卡片头部 -->
              <div class="card-header">
                <div class="card-title">
                  <div class="title-icon message-icon">
                    <i class="el-icon-chat-line-round"></i>
                  </div>
                  <div class="title-text">
                    <h3>{{ item.template_name }}</h3>
                    <span class="card-code">模版ID: {{ item.id }}</span>
                  </div>
                </div>
              </div>

              <!-- 卡片内容 -->
              <div class="card-content">
                <div class="info-item">
                  <i class="el-icon-user"></i>
                  <span class="info-label">公众号：</span>
                  <span class="info-value">{{ getGzhName(item.account_id) }}</span>
                </div>
                <!-- <div class="info-item" v-if="item.cycle_id">
                  <i class="el-icon-time"></i>
                  <span class="info-label">发送周期：</span>
                  <span class="info-value">{{ getCycleName(item.cycle_id) }}</span>
                </div>-->
                <div class="info-item">
                  <i class="el-icon-document"></i>
                  <span class="info-label">模版CODE：</span>
                  <span class="info-value code-text">{{ item.template_code }}</span>
                </div>
              </div>

              <!-- 卡片底部操作栏 -->
              <div class="card-footer">
                <!-- <div class="footer-left">
                  <span class="create-time">
                    <i class="el-icon-time"></i>
                    {{ item.create_time || '-' }}
                  </span>
                </div>-->
                <div class="footer-right">
                  <el-button
                    type="text"
                    icon="el-icon-copy-document"
                    @click="handleMessageCopy(item)"
                    class="action-btn"
                  >克隆</el-button>
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    @click="handleMessageEdit(item)"
                    class="action-btn"
                  >编辑</el-button>
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="handleMessageDelete(item)"
                    class="action-btn delete-btn"
                  >删除</el-button>
                </div>
              </div>

              <!-- 科技感光效 -->
              <div class="card-glow"></div>
            </div>

            <!-- 空状态 -->
            <div v-if="!messageLoading && messageList.length === 0" class="empty-state">
              <i class="el-icon-chat-line-round"></i>
              <p>暂无消息模版</p>
              <el-button type="primary" @click="handleMessageAdd">立即添加</el-button>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination-container" v-if="messageList.length > 0">
            <el-pagination
              @size-change="handleMessageSizeChange"
              @current-change="handleMessageCurrentChange"
              :current-page="messageQuery.pageNumber"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="messageQuery.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="messageQuery.total"
              background
            ></el-pagination>
          </div>
        </el-tab-pane>

        <!-- <el-tab-pane label="时间模版" name="time">
          <div class="search-toolbar">
            <div style="flex: 1;"></div>
            <el-button type="primary" icon="el-icon-plus" @click="handleTimeAdd">新增时间模版</el-button>
          </div>

          <div class="cards-container" v-loading="timeLoading">
            <div class="card-item time-card" v-for="item in timeList" :key="item.id">
              <div class="card-header">
                <div class="card-title">
                  <div class="title-icon time-icon">
                    <i class="el-icon-alarm-clock"></i>
                  </div>
                  <div class="title-text">
                    <h3>{{ item.cycle_name }}</h3>
                    <span class="card-code">周期ID: {{ item.id }}</span>
                  </div>
                </div>
              </div>

              <div class="card-content">
                <div class="time-configs">
                  <template v-if="getTimeConfigs(item).length > 0">
                    <div
                      class="time-config-item"
                      v-for="(config, idx) in getTimeConfigs(item)"
                      :key="idx"
                    >
                      <el-tag
                        :type="getTimeTypeTag(config.type)"
                        size="small"
                      >{{ getTimeTypeName(config.type) }}</el-tag>
                      <span class="time-text">{{ formatTimeConfig(config) }}</span>
                    </div>
                  </template>
                  <div v-else class="no-config">暂无配置</div>
                </div>
              </div>

              <div class="card-footer">
                <div class="footer-left">
                  <span class="create-time">
                    <i class="el-icon-time"></i>
                    {{ item.create_time || '-' }}
                  </span>
                </div>
                <div class="footer-right">
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    @click="handleTimeEdit(item)"
                    class="action-btn"
                  >编辑</el-button>
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="handleTimeDelete(item)"
                    class="action-btn delete-btn"
                  >删除</el-button>
                </div>
              </div>


              <div class="card-glow time-glow"></div>
            </div>


            <div v-if="!timeLoading && timeList.length === 0" class="empty-state">
              <i class="el-icon-alarm-clock"></i>
              <p>暂无时间模版</p>
              <el-button type="primary" @click="handleTimeAdd">立即添加</el-button>
            </div>
          </div>


          <div class="pagination-container" v-if="timeList.length > 0">
            <el-pagination
              @size-change="handleTimeSizeChange"
              @current-change="handleTimeCurrentChange"
              :current-page="timeQuery.pageNumber"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="timeQuery.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="timeQuery.total"
              background
            ></el-pagination>
          </div>
        </el-tab-pane>-->
      </el-tabs>
    </div>

    <!-- 消息模版抽屉 -->
    <common-drawer
      :visible.sync="messageDrawerVisible"
      :title="messageDrawerTitle"
      size="700px"
      @confirm="saveMessage"
      @cancel="handleMessageCancel"
    >
      <el-form ref="messageForm" :model="messageForm" label-width="150px" class="drawer-form">
        <!-- <el-form-item label="自动发送时间周期">
          <el-select v-model="messageForm.cycle_id" placeholder="请选择" clearable style="width:100%">
            <el-option
              v-for="item in timeList"
              :key="item.id"
              :label="item.cycle_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="模版名称" required>
          <el-input v-model="messageForm.template_name" clearable placeholder="请输入模版名称"></el-input>
        </el-form-item>
        <el-form-item label="公众号名称" required>
          <el-select
            v-model="messageForm.account_id"
            placeholder="请选择"
            clearable
            style="width:100%"
          >
            <el-option
              v-for="item in gzhList"
              :key="item.id"
              :label="item.account_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模版code" required>
          <el-input v-model="messageForm.template_code" clearable placeholder="此处为公众号复制过来的模版code"></el-input>
        </el-form-item>
        <el-form-item label="模版内容" required>
          <div
            v-for="(item, index) in messageForm.template_msg_list"
            :key="index"
            style="display: flex; margin-bottom: 10px;"
          >
            <el-input
              size="small"
              v-model="item.keyName"
              placeholder="字段中文描述"
              style="width: 150px; margin-right: 10px;"
            ></el-input>
            <el-input
              size="small"
              v-model="item.key"
              placeholder="字段英文命名"
              style="width: 150px; margin-right: 10px;"
            ></el-input>
            <el-input
              size="small"
              v-model="item.value"
              placeholder="字段默认值"
              style="flex: 1; margin-right: 10px;"
              type="textarea"
              :rows="1"
            ></el-input>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="handleDeleteItem(index)"
            ></el-button>
          </div>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddItem">添加字段</el-button>
        </el-form-item>
        <el-form-item label="跳转到url">
          <el-input v-model="messageForm.url" clearable placeholder="选填"></el-input>
        </el-form-item>
        <el-form-item label="跳转小程序appid">
          <el-input v-model="messageForm.xcx_appid" clearable placeholder="此小程序需要在公众号后台设置关联"></el-input>
        </el-form-item>
        <el-form-item label="跳转到小程序路径">
          <el-input v-model="messageForm.pagepath" clearable placeholder="页面路径如：/pages/index/index"></el-input>
        </el-form-item>
      </el-form>
    </common-drawer>

    <!-- 时间模版抽屉 -->
    <common-drawer
      :visible.sync="timeDrawerVisible"
      :title="timeDrawerTitle"
      size="900px"
      @confirm="saveTime"
      @cancel="handleTimeCancel"
    >
      <el-form ref="timeForm" :model="timeForm" label-width="100px" class="drawer-form">
        <el-form-item label="模版名称" required>
          <el-input v-model="timeForm.cycle_name" clearable placeholder="请输入时间模版名称"></el-input>
        </el-form-item>
        <el-form-item label="时间配置" required>
          <div
            v-for="(item, index) in timeForm.cycle_config"
            :key="index"
            style="display: flex; align-items: center; margin-bottom: 10px;"
          >
            <el-select
              v-model="item.type"
              placeholder="选择类型"
              clearable
              style="width: 150px; margin-right: 10px;"
            >
              <el-option
                v-for="type in typeList"
                :key="type.id"
                :label="type.name"
                :value="type.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="item.time_config.month"
              placeholder="月"
              clearable
              style="width: 80px; margin-right: 10px;"
              :disabled="item.type !== 'year'"
            >
              <el-option
                v-for="month in monthList"
                :key="month.id"
                :label="month.name"
                :value="month.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="item.time_config.week"
              placeholder="周(星期几)"
              clearable
              style="width: 120px; margin-right: 10px;"
              :disabled="item.type !== 'week'"
            >
              <el-option
                v-for="week in weekList"
                :key="week.id"
                :label="week.name"
                :value="week.id"
              ></el-option>
            </el-select>
            <el-input
              v-model="item.time_config.day"
              placeholder="日(几号)"
              type="number"
              style="width: 120px; margin-right: 10px;"
              :disabled="item.type !== 'year' && item.type !== 'month'"
            ></el-input>
            <el-time-select
              v-if="item.type !== 'fixed'"
              style="width: 220px; margin-right: 10px;"
              v-model="item.time_config.time"
              :picker-options="{
                start: '07:00',
                step: '00:15',
                end: '20:00'
              }"
              clearable
              :disabled="item.type !== 'year' && item.type !== 'month' && item.type !== 'week' && item.type !== 'day'"
              placeholder="选择时间"
              @change="changeTime(item, $event)"
            ></el-time-select>
            <el-date-picker
              v-else
              style="width: 220px; margin-right: 10px;"
              type="datetime"
              v-model="item.time_config.time"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              clearable
              placeholder="选择时间"
              @change="changeTime(item, $event)"
            ></el-date-picker>
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="removeTimeConfig(index)"
            ></el-button>
          </div>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addTimeConfig">添加时间配置</el-button>
          <div class="note">支持年、月、周、日、天、时、分的配置</div>
        </el-form-item>
      </el-form>
    </common-drawer>
  </div>
</template>

<script>
import {
  selectApi,
  updateApi,
  deleteApi,
  addApi
} from "@/services/sendService/sendTemplate";
import {
  selectApi as selectSendCycleApi,
  updateApi as updateSendCycleApi,
  deleteApi as deleteSendCycleApi,
  addApi as addSendCycleApi
} from "@/services/sendService/sendCycle";
import { selectApi as selectGzhListApi } from "@/services/sendService/sendAccount";
import CommonDrawer from "@/components/drawer/index.vue";
import { mapState } from "vuex";

export default {
  name: "TemplateManage",
  components: {
    CommonDrawer
  },
  created() {
    this.getGzhList();
    this.getTimeList();
    this.getMessageList();
  },

  data() {
    return {
      activeTab: "message",

      // 消息模版相关
      messageLoading: false,
      messageQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        template_name: ""
      },
      messageList: [],
      messageDrawerVisible: false,
      messageDrawerTitle: "",
      messageForm: {
        template_msg_list: []
      },

      // 时间模版相关
      timeLoading: false,
      timeQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      timeList: [],
      timeDrawerVisible: false,
      timeDrawerTitle: "",
      timeForm: {
        cycle_config: []
      },

      // 公众号列表
      gzhList: [],

      // 时间类型配置
      typeList: [
        { id: "day", name: "每天" },
        { id: "week", name: "每周" },
        { id: "month", name: "每月" },
        { id: "year", name: "每年" },
        { id: "fixed", name: "指定一次" }
      ],
      monthList: Array.from({ length: 12 }, (_, i) => ({
        id: String(i + 1),
        name: `${i + 1}月`
      })),
      weekList: [
        { id: "1", name: "星期一" },
        { id: "2", name: "星期二" },
        { id: "3", name: "星期三" },
        { id: "4", name: "星期四" },
        { id: "5", name: "星期五" },
        { id: "6", name: "星期六" },
        { id: "7", name: "星期日" }
      ]
    };
  },

  computed: {
    ...mapState(["userInfo"])
  },

  methods: {
    // Tab 切换
    handleTabClick(tab) {
      console.log("切换Tab:", tab.name);
    },

    // ========== 消息模版相关方法 ==========
    async getMessageList() {
      this.messageLoading = true;
      const { data, code, count } = await selectApi(this.messageQuery);
      if (code === 200) {
        this.messageList = data;
        this.messageQuery.total = count;
        setTimeout(() => {
          this.messageLoading = false;
        }, 300);
      }
    },

    handleMessageCurrentChange(page) {
      this.messageQuery.pageNumber = page;
      this.getMessageList();
    },

    handleMessageSizeChange(size) {
      this.messageQuery.pageSize = size;
      this.getMessageList();
    },

    handleMessageAdd() {
      this.messageDrawerVisible = true;
      this.messageDrawerTitle = "新增消息模版";
      this.messageForm = {
        template_msg_list: []
      };
      this.$nextTick(() => {
        this.$refs.messageForm && this.$refs.messageForm.clearValidate();
      });
    },

    handleMessageEdit(row) {
      this.messageDrawerVisible = true;
      this.messageDrawerTitle = "编辑消息模版";
      this.messageForm = JSON.parse(JSON.stringify(row));
      try {
        this.messageForm.template_msg_list =
          JSON.parse(this.messageForm.template_msg_list) || [];
      } catch (error) {
        this.messageForm.template_msg_list = [];
      }
      this.$nextTick(() => {
        this.$refs.messageForm && this.$refs.messageForm.clearValidate();
      });
    },

    handleMessageCopy(row) {
      this.$confirm(`是否确定克隆模版'${row.template_name}'？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const copyData = { ...row };
          delete copyData.id;
          addApi(copyData).then(res => {
            if (res.code === 200) {
              this.$message.success("克隆成功!");
              this.getMessageList();
            }
          });
        })
        .catch(() => {});
    },

    handleMessageDelete(row) {
      this.$confirm(
        `此操作将永久删除'${row.template_name}'，是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          deleteApi({ id: row.id }).then(res => {
            this.$message.success("删除成功!");
            this.getMessageList();
          });
        })
        .catch(() => {});
    },

    handleAddItem() {
      this.messageForm.template_msg_list.push({
        keyName: "",
        key: "",
        value: ""
      });
    },

    handleDeleteItem(index) {
      this.messageForm.template_msg_list.splice(index, 1);
    },

    transformArrayToObject(array) {
      let transformed = {};
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const { key, value } = item;
        transformed[key] = { value };
      }
      return transformed;
    },

    saveMessage() {
      let formData = JSON.parse(JSON.stringify(this.messageForm));

      // 校验
      if (formData.template_msg_list.length === 0) {
        this.$message.error("请添加模版字段");
        return;
      }
      for (let i = 0; i < formData.template_msg_list.length; i++) {
        const item = formData.template_msg_list[i];
        if (!item.keyName || !item.key || !item.value) {
          this.$message.error("请完善模版字段");
          return;
        }
      }

      try {
        formData.template_msg = JSON.stringify(
          this.transformArrayToObject(formData.template_msg_list)
        );
      } catch (error) {
        formData.template_msg = null;
      }

      try {
        formData.template_msg_list = JSON.stringify(formData.template_msg_list);
      } catch (error) {
        formData.template_msg_list = null;
      }

      if (!formData?.cycle_id) {
        formData.cycle_id = null;
      }

      if (
        !formData.account_id ||
        !formData.template_code ||
        !formData.template_name ||
        !formData.template_msg
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      if (this.messageDrawerTitle === "新增消息模版") {
        addApi(formData).then(res => {
          if (res.code === 200) {
            this.$message.success("新增成功!");
            this.messageDrawerVisible = false;
            this.getMessageList();
          }
        });
      } else {
        updateApi(formData).then(res => {
          if (res.code === 200) {
            this.$message.success("修改成功!");
            this.messageDrawerVisible = false;
            this.getMessageList();
          }
        });
      }
    },

    handleMessageCancel() {
      this.messageDrawerVisible = false;
    },

    // ========== 时间模版相关方法 ==========
    async getTimeList() {
      this.timeLoading = true;
      const { data, code, count } = await selectSendCycleApi(this.timeQuery);
      if (code === 200) {
        this.timeList = data;
        this.timeQuery.total = count;
        setTimeout(() => {
          this.timeLoading = false;
        }, 300);
      }
    },

    handleTimeCurrentChange(page) {
      this.timeQuery.pageNumber = page;
      this.getTimeList();
    },

    handleTimeSizeChange(size) {
      this.timeQuery.pageSize = size;
      this.getTimeList();
    },

    handleTimeAdd() {
      this.timeDrawerVisible = true;
      this.timeDrawerTitle = "新增时间模版";
      this.timeForm = {
        cycle_name: "",
        cycle_config: [
          {
            type: "",
            time_config: {
              time: "",
              week: "",
              day: "",
              month: ""
            }
          }
        ]
      };
      this.$nextTick(() => {
        this.$refs.timeForm && this.$refs.timeForm.clearValidate();
      });
    },

    handleTimeEdit(row) {
      this.timeDrawerVisible = true;
      this.timeDrawerTitle = "编辑时间模版";
      this.timeForm = JSON.parse(JSON.stringify(row));

      if (typeof this.timeForm.cycle_config === "string") {
        try {
          this.timeForm.cycle_config = JSON.parse(this.timeForm.cycle_config);
        } catch (error) {
          this.timeForm.cycle_config = [];
        }
      }

      if (!Array.isArray(this.timeForm.cycle_config)) {
        this.timeForm.cycle_config = [];
      }

      this.$nextTick(() => {
        this.$refs.timeForm && this.$refs.timeForm.clearValidate();
      });
    },

    handleTimeDelete(row) {
      this.$confirm(`此操作将永久删除'${row.cycle_name}'，是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteSendCycleApi({ id: row.id }).then(res => {
            this.$message.success("删除成功!");
            this.getTimeList();
          });
        })
        .catch(() => {});
    },

    addTimeConfig() {
      this.timeForm.cycle_config.push({
        type: "",
        time_config: {
          time: "",
          week: "",
          day: "",
          month: ""
        }
      });
    },

    removeTimeConfig(index) {
      this.timeForm.cycle_config.splice(index, 1);
    },

    changeTime(item, event) {
      if (event && !event.includes(":00")) {
        item.time_config.time = event + ":00";
      }
    },

    saveTime() {
      if (!this.timeForm.cycle_name || !this.timeForm.cycle_config) {
        this.$message.error("请填写必填字段");
        return;
      }

      const data = {
        cycle_name: this.timeForm.cycle_name,
        cycle_config: JSON.stringify(this.timeForm.cycle_config)
      };

      if (this.timeDrawerTitle === "新增时间模版") {
        addSendCycleApi(data).then(res => {
          if (res.code === 200) {
            this.$message.success("新增成功!");
            this.timeDrawerVisible = false;
            this.getTimeList();
          }
        });
      } else {
        updateSendCycleApi({ ...data, id: this.timeForm.id }).then(res => {
          if (res.code === 200) {
            this.$message.success("修改成功!");
            this.timeDrawerVisible = false;
            this.getTimeList();
          }
        });
      }
    },

    handleTimeCancel() {
      this.timeDrawerVisible = false;
    },

    // ========== 公共方法 ==========
    async getGzhList() {
      const result = await selectGzhListApi({
        pageNumber: 1,
        pageSize: 100
      });
      if (result.code === 200) {
        this.gzhList = result.data;
      }
    },

    getGzhName(id) {
      const item = this.gzhList.find(g => g.id === id);
      return item ? item.account_name : "-";
    },

    getCycleName(id) {
      const item = this.timeList.find(t => t.id === id);
      return item ? item.cycle_name : "-";
    },

    getTimeConfigs(item) {
      if (typeof item.cycle_config === "string") {
        try {
          return JSON.parse(item.cycle_config);
        } catch (error) {
          return [];
        }
      }
      return Array.isArray(item.cycle_config) ? item.cycle_config : [];
    },

    getTimeTypeName(type) {
      const item = this.typeList.find(t => t.id === type);
      return item ? item.name : type;
    },

    getTimeTypeTag(type) {
      const tagMap = {
        day: "",
        week: "success",
        month: "warning",
        year: "danger",
        fixed: "info"
      };
      return tagMap[type] || "";
    },

    formatTimeConfig(config) {
      const { type, time_config } = config;
      let result = "";

      if (type === "year" && time_config.month) {
        result += `${time_config.month}月`;
      }
      if ((type === "year" || type === "month") && time_config.day) {
        result += `${time_config.day}日`;
      }
      if (type === "week" && time_config.week) {
        const week = this.weekList.find(w => w.id === time_config.week);
        result += week ? week.name : "";
      }
      if (time_config.time) {
        result += ` ${time_config.time}`;
      }

      return result || "未配置";
    }
  }
};
</script>

<style scoped lang="less">
.template-container {
  padding: 20px;
  min-height: 60vh;
  max-height: 90vh;
  overflow-y: scroll;

  // 头部工具栏
  .header-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 20px 30px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);

    .toolbar-left {
      display: flex;
      align-items: center;
      gap: 20px;
    }

    .page-title {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      gap: 10px;

      i {
        font-size: 28px;
        color: #409eff;
      }
    }
  }

  // Tab 容器
  .tabs-container {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

    /deep/ .el-tabs__header {
      margin-bottom: 20px;
    }

    /deep/ .el-tabs__item {
      font-size: 16px;
      font-weight: 500;
    }

    /deep/ .el-tabs__item.is-active {
      color: #409eff;
    }

    /deep/ .el-tabs__active-bar {
      background-color: #409eff;
    }
  }

  // 搜索工具栏
  .search-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    gap: 20px;

    .search-input {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        border-color: #409eff;
        color: #fff;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          background-color: #66b1ff;
        }
      }
    }
  }

  // 卡片容器
  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    gap: 24px;
    min-height: 300px;
    align-content: start;

    // 单个卡片
    .card-item {
      position: relative;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 16px;
      padding: 24px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      overflow: hidden;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 16px 48px rgba(64, 158, 255, 0.3);

        .card-glow {
          opacity: 1;
        }
      }

      // 科技感光效
      .card-glow {
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(
          circle,
          rgba(64, 158, 255, 0.15) 0%,
          transparent 70%
        );
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;

        &.time-glow {
          background: radial-gradient(
            circle,
            rgba(230, 162, 60, 0.15) 0%,
            transparent 70%
          );
        }
      }

      // 卡片头部
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 20px;
        padding-bottom: 16px;
        border-bottom: 2px solid #f0f0f0;

        .card-title {
          display: flex;
          align-items: center;
          gap: 12px;
          flex: 1;

          .title-icon {
            width: 48px;
            height: 48px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;

            &.message-icon {
              background: linear-gradient(135deg, #66b1ff 0%, #409eff 100%);
            }

            &.time-icon {
              background: linear-gradient(135deg, #f0c78a 0%, #e6a23c 100%);
            }

            i {
              font-size: 24px;
              color: #fff;
            }
          }

          .title-text {
            flex: 1;

            h3 {
              margin: 0 0 6px 0;
              font-size: 18px;
              font-weight: 600;
              color: #333;
              line-height: 1.2;
            }

            .card-code {
              font-size: 12px;
              color: #999;
              font-family: "Courier New", monospace;
              background: #f5f5f5;
              padding: 2px 8px;
              border-radius: 4px;
              display: inline-block;
            }
          }
        }
      }

      // 卡片内容
      .card-content {
        margin-bottom: 20px;

        .info-item {
          display: flex;
          align-items: flex-start;
          padding: 10px 0;
          color: #666;
          font-size: 14px;

          i {
            font-size: 16px;
            margin-right: 8px;
            color: #409eff;
            margin-top: 2px;
            flex-shrink: 0;
          }

          .info-label {
            font-weight: 500;
            margin-right: 8px;
            color: #666;
            flex-shrink: 0;
          }

          .info-value {
            flex: 1;
            color: #333;
            word-break: break-all;

            &.code-text {
              font-family: "Courier New", monospace;
              font-size: 13px;
            }
          }
        }

        // 时间配置项
        .time-configs {
          .time-config-item {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 10px;
            padding: 8px 12px;
            background: #f5f7fa;
            border-radius: 8px;

            .time-text {
              font-size: 14px;
              color: #333;
            }
          }

          .no-config {
            color: #999;
            font-size: 14px;
            text-align: center;
            padding: 20px;
          }
        }
      }

      // 卡片底部
      .card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;

        .footer-left {
          .create-time {
            font-size: 12px;
            color: #999;
            display: flex;
            align-items: center;
            gap: 4px;

            i {
              font-size: 14px;
            }
          }
        }

        .footer-right {
          display: flex;
          gap: 8px;

          .action-btn {
            padding: 8px 16px;
            font-size: 13px;

            &:hover {
              color: #409eff;
            }

            &.delete-btn:hover {
              color: #f56c6c;
            }
          }
        }
      }
    }

    // 空状态
    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 80px 20px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
      grid-column: 1 / -1;

      i {
        font-size: 80px;
        color: #ddd;
        margin-bottom: 20px;
      }

      p {
        font-size: 16px;
        color: #999;
        margin-bottom: 20px;
      }
    }
  }

  // 分页
  .pagination-container {
    margin-top: 20px;
    padding: 20px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
  }

  // 抽屉表单
  .drawer-form {
    padding: 10px 0;

    .note {
      margin-top: 10px;
      font-size: 12px;
      color: #999;
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .template-container {
    .cards-container {
      grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)) !important;
    }
  }
}

@media (max-width: 768px) {
  .template-container {
    padding: 10px;

    .header-toolbar {
      padding: 15px;
    }

    .tabs-container {
      padding: 15px;
    }

    .search-toolbar {
      flex-direction: column;
      align-items: stretch;

      .search-input {
        width: 100% !important;
      }
    }

    .cards-container {
      grid-template-columns: 1fr !important;
    }
  }
}
</style>
